import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=47340fba&scoped=true&"
import script from "./TermsAndConditions.js?vue&type=script&lang=js&"
export * from "./TermsAndConditions.js?vue&type=script&lang=js&"
import style0 from "./TermsAndConditions.scss?vue&type=style&index=0&id=47340fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47340fba",
  null
  
)

export default component.exports